export default class UnregisteredComponentError extends Error {

}
